export function validateDpiitNumber(name) {
  var nameRegex = /^[ A-Za-z0-9_@./#&+-]*$/;

  if (name === "" || name === undefined || name === null) {
    return {
      status: false,
      error: "Please enter your Usernname",
      hasError: true,
    };
  } else if (!nameRegex.test(name)) {
    return {
      status: false,
      error: "Please provide valid Usernname",
      hasError: true,
    };
  } else if (name.length < 2) {
    return {
      status: false,
      error: "Please provide valid Usernname",
      hasError: true,
    };
  } else {
    return { status: true, error: "", hasError: false };
  }
}

/*to handle url validation*/
export function validateUrl(name, msgText) {
  // var nameRegex =v
  //   /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gm;

  var nameRegex = new RegExp(
    // "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?"
    "((http|https)://)(www.)?" +
      "[a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\\.[a-z]" +
      "{2,6}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)"
  );

  if (name === "" || name === undefined || name === null) {
    return { status: true, error: "", hasError: false };
  } else if (!nameRegex.test(name)) {
    return {
      status: false,
      error: msgText,
      hasError: true,
    };
  } else if (name.length < 2) {
    return {
      status: false,
      error: msgText,
      hasError: true,
    };
  } else {
    return { status: true, error: "", hasError: false };
  }
}

/* To handle first name validation*/
export function validateUserName(name) {
  var nameRegex = /^(?![\s.]+$)[a-zA-Z\s.]*$/;

  if (name === "" || name === undefined || name === null) {
    return {
      status: false,
      error: "Please enter your Usernname",
      hasError: true,
    };
  } else if (!nameRegex.test(name)) {
    return {
      status: false,
      error: "Please provide valid Usernname",
      hasError: true,
    };
  } else if (name.length < 2) {
    return {
      status: false,
      error: "Please provide valid Usernname",
      hasError: true,
    };
  } else {
    return { status: true, error: "", hasError: false };
  }
}
export function validateName(name, msgText) {
  var nameRegex = /^(?![\s.]+$)[a-zA-Z\s.]*$/;

  if (name === "" || name === undefined || name === null) {
    return { status: false, error: msgText, hasError: true };
  } else if (!nameRegex.test(name)) {
    return {
      status: false,
      error: "Special characters not allowed, please enter valid text",
      hasError: true,
    };
  } else if (name.length < 2) {
    return {
      status: false,
      error: msgText,
      hasError: true,
    };
  } else {
    return { status: true, error: "", hasError: false };
  }
}
export function validateName2(name, msgText) {
  // var nameRegex = /^(?![\s.]+$)[a-zA-Z\s.]*$/;

  if (name === "" || name === undefined || name === null) {
    return { status: false, error: msgText, hasError: true };
  } 
  // else if (!nameRegex.test(name)) {
  //   return {
  //     status: false,
  //     error: "Special characters not allowed, please enter valid text",
  //     hasError: true,
  //   };
  // } 
  else if (name.length < 3) {
    return {
      status: false,
      error: msgText,
      hasError: true,
    };
  } else {
    return { status: true, error: "", hasError: false };
  }
}
export function validateDesc(name, msgText) {
  var nameRegex = /^(?![\s.]+$)[a-zA-Z\s.]*$/;

  if (name === "" || name === undefined || name === null) {
    return { status: false, error: msgText, hasError: true };
  }
  // else if (!nameRegex.test(name)) {
  //   return {
  //     status: false,
  //     error: "Special characters not allowed, please enter valid text",
  //     hasError: true,
  //   };
  // }
  else if (name.length < 2) {
    return {
      status: false,
      error: msgText,
      hasError: true,
    };
  } else {
    return { status: true, error: "", hasError: false };
  }
}
export function validateNameinCohort(name, msgText) {
  var nameRegex = /^(?![\s.]+$)[a-zA-Z\s.]*$/;

  if (name === "" || name === undefined || name === null) {
    return { status: false, error: msgText, hasError: true };
  }
  // else if (!nameRegex.test(name)) {
  //   return {
  //     status: false,
  //     error: "Special characters not allowed, please enter valid text",
  //     hasError: true,
  //   };
  // }
  else if (name.length < 2) {
    return {
      status: false,
      error: msgText,
      hasError: true,
    };
  } else {
    return { status: true, error: "", hasError: false };
  }
}
export function validateNameinContact(name, msgText) {
  var nameRegex = /^(?![\s.]+$)[a-zA-Z\s.]*$/;

  if (name === "" || name === undefined || name === null) {
    return { status: false, error: msgText, hasError: true };
  } else if (name.length < 2) {
    return {
      status: false,
      error: msgText,
      hasError: true,
    };
  } else {
    return { status: true, error: "", hasError: false };
  }
}
export function validateName00(name, msgText) {
  if (name === "" || name === undefined || name === null) {
    return { status: false, error: msgText, hasError: true };
  } else if (name.length < 2) {
    return {
      status: false,
      error: msgText,
      hasError: true,
    };
  } else if (name.length > 1) {
    return { status: true, error: "", hasError: false };
  }
}
export function validateDuration(duration, msgText) {
  if (duration === "" || duration === undefined || duration === null) {
    return { status: true, error: "", hasError: false };
  } else if (duration < 3) {
    return {
      status: false,
      error: msgText,
      hasError: true,
    };
  } else {
    return { status: true, error: "", hasError: false };
  }
}
export function validateDurationText(duration, msgText) {
  const temp = parseInt(duration);
  if (duration === "" || duration === undefined || duration === null) {
    return { status: true, error: "", hasError: false };
  } else {
    duration = duration.trim().toLowerCase();
    if (duration == "one" || duration == "two" || duration == "zero" || temp) {
      return { status: false, error: msgText, hasError: true };
    } else {
      return { status: true, error: "", hasError: false };
    }
  }
}
export function validateDesignation(name, msgText) {
  // var nameRegex = /^(?![\s.]+$)[a-zA-Z\s.]*$/;

  if (name === "" || name === undefined || name === null) {
    return { status: false, error: msgText, hasError: true };
  } else if (name.length < 2) {
    return {
      status: false,
      error: msgText,
      hasError: true,
    };
  } else {
    return { status: true, error: "", hasError: false };
  }
}

export function validateEmail(email) {
  let emailRegex =
    /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,10})$/;
  if (email === "" || email === undefined || email === null) {
    return { status: false, error: "Please enter email ID *", hasError: true };
  } else if (!emailRegex.test(email)) {
    return {
      status: false,
      error: "Please enter valid email ID *",
      hasError: true,
    };
  } else {
    return { status: true, error: "", hasError: false };
  }
}

/* To validate login password */
export function validateLoginPassword(password) {
  if (password === "" || password === undefined || password === null) {
    return {
      status: false,
      error: "Please enter valid password *",
      hasError: true,
    };
  } else {
    return { status: true, error: "", hasError: false };
  }
}
export function validatelCountry(text, msgText) {
  if (text === "" || text === undefined || text === null) {
    return {
      status: false,
      error: msgText,
      hasError: true,
    };
  } else {
    return { status: true, error: "", hasError: false };
  }
}
export function validateCity(city, msgText) {
  if (city && city.value != "") {
    if (city === "" || city === undefined || city === null) {
      return { status: false, error: msgText, hasError: true };
    } else {
      return { status: true, error: "", hasError: false };
    }
  } else {
    return { status: false, error: msgText, hasError: true };
  }
}
export function validatelCountrySate(text, msgText, country) {
  var numberRegex = /^[0-9\b]+$/;
  if (country && country.value === "IN") {
    if (text === "" || text === undefined || text === null) {
      return { status: false, error: msgText, hasError: true };
    } else {
      return { status: true, error: "", hasError: false };
    }
  } else {
    return { status: true, error: "", hasError: false };
  }
}
export function validatelCountrySateContact(text, msgText) {
  var numberRegex = /^[0-9\b]+$/;

  if (text === "" || text === undefined || text === null) {
    return { status: false, error: msgText, hasError: true };
  } else {
    return { status: true, error: "", hasError: false };
  }
}

export function validatelotherCountryCity(msgText, country, otherCity) {
  var numberRegex = /^[0-9\b]+$/;
  if (country && country.value === "IN") {
    if (otherCity === "" || otherCity === undefined || otherCity === null) {
      return { status: false, error: msgText, hasError: true };
    } else {
      return { status: true, error: "", hasError: false };
    }
  } else {
    if (otherCity === "" || otherCity === "undefined" || otherCity === null) {
      return { status: false, error: msgText, hasError: true };
    } else {
      return { status: true, error: "", hasError: false };
    }
  }
}

export function validateFile(file, msgText) {
  if (file === "" || file === undefined || file === null) {
    return {
      status: false,
      error: msgText,
      hasError: true,
    };
  } else {
    // alert(file.size)
    const fileSize = file.size / 1024 / 1024; // in MB
    if (fileSize > 2) {
      // alert('File size exceeds 2 MB');
      return {
        status: false,
        error: "File size exceeds 2 MB",
        hasError: true,
      };
    } else {
      return { status: true, error: "", hasError: false };
    }
  }
}
export function validateFile00(file, msgText) {
  if (file === "" || file === undefined || file === null) {
    return {
      status: false,
      error: msgText,
      hasError: true,
    };
  } else {
    // alert(file.size)
    const fileSize = file.size / 1024 / 1024; // in MB
    if (fileSize > 10) {
      // alert('File size exceeds 2 MB');
      return {
        status: false,
        error: "File size exceeds 10 MB",
        hasError: true,
      };
    } else {
      return { status: true, error: "", hasError: false };
    }
  }
}
export function validatePofilePicture(file, msgText) {
  if (file === "" || file === undefined || file === null) {
    return { status: true, error: "", hasError: false };
  } else {
    // alert(file.size/ 1000)
    const fileSize = file.size / 1000; // 500 kb
    if (fileSize > 500) {
      return {
        status: false,
        error: "File size exceeds 500KB",
        hasError: true,
      };
    } else {
      return { status: true, error: "", hasError: false };
    }
  }
}
export function validateBanner(file, msgText) {
  if (file === "" || file === undefined || file === null) {
    if (
      !localStorage.getItem("uploadBanner") ||
      localStorage.getItem("uploadBanner") === null ||
      localStorage.getItem("uploadBanner") === "" ||
      localStorage.getItem("uploadBanner") === undefined
    ) {
      return { status: false, error: msgText, hasError: true };

    } else {
      return { status: false, error: msgText, hasError: true };

    }
  } else {
    // alert(file.size)
    const fileSize = file.size / 1024 / 1024; // in MB
    if (fileSize > 2) {
      // alert('File size exceeds 2 MB');
      return {
        status: false,
        error: "File size exceeds 2 MB",
        hasError: true,
      };
    } else {
      return { status: true, error: "", hasError: false };
    }
  }
}
export function validateSelectField(list, msgText) {
  if (list !== null && list?.length > 0) {
    return { status: true, error: "", hasError: false };
  } else {
    return {
      status: false,
      error: msgText,
      hasError: true,
    };
  }
}
export function validateSelectFieldlabel(list, msgText) {
  if (list !== null && list?.length > 0) {
    return { status: true, error: "", hasError: false };
  } else if (list !== null && list?.label) {
    return { status: true, error: "", hasError: false };
  } else {
    return {
      status: false,
      error: msgText,
      hasError: true,
    };
  }
}
export function validateSelectFieldMulti(list, list2, msgText) {
  if ((list !== null && list.length > 0) || list2.length === 10) {
    return { status: true, error: "", hasError: false };
  } else if (list !== null && list.label) {
    return { status: true, error: "", hasError: false };
  } else {
    return {
      status: false,
      error: msgText,
      hasError: true,
    };
  }
}
export function validateTotalSelectField(list, msgText) {
  if (list !== null && list.length > 0) {
    return { status: true, error: "", hasError: false, length: list.length };
  } else {
    return {
      status: false,
      error: msgText,
      hasError: true,
      length: list.length,
    };
  }
}
export function validateDisclaimer(value) {
  if (value === false) {
    return {
      status: false,
      error: "*Select Disclaimer",
      hasError: true,
    };
  } else {
    return { status: true, error: "", hasError: false };
  }
}
export function validateCohortVisibility(value) {
  let valueTester = (value === true || value === false) ? false : true; 
  if (valueTester) {
    return {
      status: false,
      error: "*Select Cohort Visibility",
      hasError: true,
    };
  } else {
    return { status: true, error: "", hasError: false };
  }
}
const removeExtraSpace = (s) => s.trim().split(/ +/).join(" ");
const removeNewLine = (s) => s.trim().split("\n").join(" ");
export function validate100TextArea(value, msgText) {
  // debugger;
  const newLine = removeNewLine(value);
  const name = removeExtraSpace(newLine);

  let wordsCount = name && name.split(" ").length;
  let nameRegex = /^(?!\s)(?![\s\S]*\s$)/;
  if (name === "" || name === undefined || name === null) {
    return { status: false, error: msgText, hasError: true };
  }
  // else if (!nameRegex.test(name)) {
  //     return { status: false, error: "Should not start or end  with  blank space.", hasError: true }
  // }
  else if (wordsCount > 100) {
    return {
      status: false,
      error: "*Exceeds 100 Word Limit",
      hasError: true,
    };
  } else {
    return { status: true, error: "", hasError: false };
  }
}
export function validate500TextArea(value, msgText) {
  const name = removeExtraSpace(value);

  let wordsCount = name && name.split(" ").length;
  let nameRegex = /^(?!\s)(?![\s\S]*\s$)/;
  if (name === "" || name === undefined || name === null) {
    return { status: false, error: msgText, hasError: true };
  } else if (wordsCount > 500) {
    return {
      status: false,
      error: msgText,
      hasError: true,
    };
  } else {
    return { status: true, error: "", hasError: false };
  }
}
export function validate200TextAreaNonMandatory(value, msgText) {
  const textData = removeNewLine(value);
  const name = removeExtraSpace(textData);

  let wordsCount = name && name.split(" ").length;
  let nameRegex = /^(?!\s)(?![\s\S]*\s$)/;
  if (name === "" || name === undefined || name === null) {
    return { status: true, error: "", hasError: false };
  } else if (wordsCount > 200) {
    return {
      status: false,
      error: "Exceeds 200 Word Limit",
      hasError: true,
    };
  } else {
    return { status: true, error: "", hasError: false };
  }
}

export function validateNumber(number, msgText) {
  var numberRegex = /^[0-9\b]+$/;
  // debugger;
  if (number === "" || number === undefined || number === null) {
    return {
      status: false,
      error: msgText,
      hasError: true,
    };
  } else if (number < 0 || number > 150) {
    return {
      status: false,
      error: "Number Should Not be Greater than 150",
      hasError: true,
    };
  } else if (!numberRegex.test(number)) {
    return {
      status: false,
      error: "Please Enter Valid Number",
      hasError: true,
    };
  } else {
    if (number.length > 0) {
      return { status: true, error: "", hasError: false };
    } else {
      return { status: false, error: msgText, hasError: true };
    }
  }
}
export function validateNumber15(number, msgText) {
  var numberRegex = /^[0-9\b]+$/;
  // debugger;
  // if (number === "" || number === undefined || number === null) {
  //   return {
  //     status: false,
  //     error: msgText,
  //     hasError: true,
  //   };
  // } else

  if (number < 0 || number > 15) {
    return {
      status: false,
      error: "Number Should Not be Greater than 15",
      hasError: true,
    };
  } else if ((number < 0 || number > 15) && !numberRegex.test(number)) {
    return {
      status: false,
      error: "Please Enter Valid Number",
      hasError: true,
    };
  } else {
    return { status: true, error: "", hasError: false };
  }
  // else {
  //   if (number.length > 0) {
  //     return { status: true, error: "", hasError: false };
  //   } else {
  //     return { status: false, error: msgText, hasError: true };
  //   }
  // }
}
export function validateNumber00(number, msgText) {
  var numberRegex = /^[0-9\b]+$/;
  // debugger;
  if (number === "" || number === undefined || number === null) {
    return {
      status: false,
      error: msgText,
      hasError: true,
    };
  } else if (number < 0 || number > 150) {
    return {
      status: false,
      error: "Number Should Not be Greater than 150",
      hasError: true,
    };
  } else if (!numberRegex.test(number)) {
    return {
      status: false,
      error: "Please Enter Valid Number",
      hasError: true,
    };
  } else {
    if (number >= 2) {
      return { status: true, error: "", hasError: false };
    } else {
      return {
        status: false,
        error: "Minimum 2 mentors need to be added",
        hasError: true,
      };
    }
  }
}
export function validateNumber01(number, msgText) {
  var numberRegex = /^[0-9\b]+$/;
  // debugger;
  if (number === "" || number === undefined || number === null) {
    return {
      status: false,
      error: msgText,
      hasError: true,
    };
  } else if (number < 0 || number > 16) {
    return {
      status: false,
      error: "Number Should Not be Greater than 15",
      hasError: true,
    };
  } else if (!numberRegex.test(number)) {
    return {
      status: false,
      error: "Please Enter Valid Number",
      hasError: true,
    };
  } else {
    if (number > 0 && number <= 15) {
      return { status: true, error: "", hasError: false };
    } else if (number == 0) {
      return {
        status: false,
        error: "Number Should be atleast 1",
        hasError: true,
      };
    } else {
      return {
        status: false,
        error: "Number Should Not be Greater than 15",
        hasError: true,
      };
    }
  }
}
export function validateNumber002(number, msgText) {
  var numberRegex = /^[0-9\b]+$/;
  // debugger;
  if (number === "" || number === undefined || number === null) {
    return {
      status: false,
      error: msgText,
      hasError: true,
    };
  } else if (number > 500) {
    return {
      status: false,
      error: "Number Should Not be Greater than 500",
      hasError: true,
    };
  } else if (!numberRegex.test(number)) {
    return {
      status: false,
      error: "Please Enter Valid Number",
      hasError: true,
    };
  } else if (number < 2) {
    return {
      status: false,
      error: "Number Should be atleast 2",
      hasError: true,
    };
  } else if (number > 0 && number <= 500) {
    return { status: true, error: "", hasError: false };
  } else {
    return {
      status: false,
      error: "Number Should Not be Greater than 500",
      hasError: true,
    };
  }
}

export function validateNumber12(duration,infiniteDuration, msgText) {
  var numberRegex = /^[0-9\b]+$/;

  if ((duration === "" || duration === undefined || duration === null ) && !infiniteDuration) {
    return { status: false, error: "*Please Enter Program Duration", hasError: true };
  } else if (duration < 3 && !infiniteDuration) {
    return {
      status: false,
      error: msgText,
      hasError: true,
    };
  } else if (!numberRegex.test(duration) && !infiniteDuration) {
    return {
      status: false,
      error: "Please Enter Valid Month",
      hasError: true,
    };
  } else if ((duration < 0 || duration > 12) && !infiniteDuration) {
    return {
      status: false,
      error: "Month Should Not be Greater than 12",
      hasError: true,
    };
  } else {
    return { status: true, error: "", hasError: false };
  }
}

export function validateDate(date, msgText) {
  // var numberRegex = /^[0-9\b]+$/;

  if (date === "" || date === undefined || date === null) {
    return { status: false, error: msgText, hasError: true };
  } else {
    return { status: true, error: "", hasError: false };
  }
}
export function validateDate2(date, msgText,infiniteDuration) {
  // var numberRegex = /^[0-9\b]+$/;

  if ((date === "" || date === undefined || date === null) && !infiniteDuration) {
    return { status: false, error: msgText, hasError: true };
  } else {
    return { status: true, error: "", hasError: false };
  }
}
function hasDuplicates(arr) {
  return new Set(arr).size !== arr.length;
}
export function validateMentorID(
  mentorenrolmentid,
  numberofmentors,
  defaultMentorID,
  msgText
) {
  let result;

  let mentorData = [];
  Object.keys(mentorenrolmentid).map(function (key, index) {
    mentorenrolmentid[key].mentorenrolmentid !== "" &&
      mentorData.push(mentorenrolmentid[key].mentorenrolmentid);
  });

  if (mentorData?.length === 0) {
    mentorData = defaultMentorID;
  }

  if (mentorData?.length < 2) {
    return { status: false, error: "Add more MentorID", hasError: true };
  }
  if (hasDuplicates(mentorData) && mentorData?.length < 2) {
    return {
      status: false,
      error: "Add more MentorID and avoid duplicate MentorID",
      hasError: true,
    };
  } else if (hasDuplicates(mentorData) && mentorData?.length >= 2) {
    return {
      status: false,
      error: "Duplicate MentorID found.",
      hasError: true,
    };
  } else if (hasDuplicates(mentorData) === false && mentorData?.length < 2) {
    return { status: false, error: "Add more MentorID", hasError: true };
  } else if (hasDuplicates(mentorData) === false && mentorData?.length >= 2) {
    return { status: true, error: "", hasError: false };
  }
}

export function validateNumber2(number, msgText) {
  if (number === "" || number === undefined || number === null) {
    return {
      status: false,
      error: msgText,
      hasError: true,
    };
  } else {
    if (number.length > 0) {
      return { status: true, error: "", hasError: false };
    } else {
      return { status: false, error: msgText, hasError: true };
    }
  }
}

export function validateCurrentRevenue(number, msgText) {
  var numberRegex = /^[0-9\b]+$/;
  if (number === "" || number === undefined || number === null) {
    return {
      status: true,
      error: "",
      hasError: false,
    };
  } else if (!numberRegex.test(number)) {
    return {
      status: false,
      error: "Please Enter Valid Number",
      hasError: true,
    };
  } else {
    if (number.length > 0) {
      return { status: true, error: "", hasError: false };
    } else {
      return { status: false, error: msgText, hasError: true };
    }
  }
}

export function validatelMobileNo(mobileNo, msgText, Country) {
  var numberRegex = /^[0-9\b]+$/;
  if (mobileNo === "" || mobileNo === undefined || mobileNo === null) {
    return {
      status: false,
      error: msgText,
      hasError: true,
    };
  } else {
    if (mobileNo.length > 1) {
      if (!numberRegex.test(mobileNo)) {
        return { status: false, error: msgText, hasError: true };
      } else {
        if (Country && Country.value == "IN") {
          if (mobileNo.length === 12) {
            return { status: true, error: "", hasError: false };
          } else {
            return { status: false, error: msgText, hasError: true };
          }
        } else if (mobileNo.length < 5) {
          return { status: false, error: msgText, hasError: true };
        } else {
          return { status: true, error: "", hasError: false };
        }
      }
    } else {
      return { status: true, error: "", hasError: false };
    }
  }
}
